import { v4 as uuid } from "uuid";
import { useSelector, useDispatch } from 'react-redux'

import store, {history} from '@/redux/store';
import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'

import {WINDOW} from "@/actions/globalConst";


import DB from "@/models/DB";
import {WindowModel} from "@/models/Window";

const Test = React.lazy(() => import( "@/views/base/Buttons/Test.js" ));
const AddTask = React.lazy(() => import( "@/controllers/Settings/AddTaskController.js" ));
const Search = React.lazy(() => import( "@/controllers/Window/Search/WindowSearchController" ));
const TimeReg = React.lazy(() => import( "@/controllers/Window/Search/WindowSearchTimeRegistrationController" ));
const SearchDossier = React.lazy(() => import( "@/controllers/Window/Search/WindowSearchDossierController" ));
const WindowDropbox = React.lazy(() => import( "@/controllers/Window/Dropbox/WindowDropboxController" ));
const SetTimeRegistration = React.lazy(() => import( "@/controllers/Window/Childs/WindowSetTimeRegistrationController" ));
const WindowController = React.lazy(() => import( "@/controllers/Window/CommunicationCyncle/WindowTodoController" ));
const ContactController = React.lazy(() => import( "@/controllers/Window/CommunicationCyncle/WindowContactController" ));
const AppointmentView = React.lazy(() => import( "@/views/Window/CommunicationCycle/AppointmentView" ));

const WorkhourView= React.lazy(() => import( "@/views/Window/Settings/Workhour" ));
const ColorSelectView= React.lazy(() => import( "@/views/Window/Settings/Color" ));
const SearchCompanyWorkersPersonView = React.lazy(() => import( "@/views/Window/Search/CompanyWorkersPersons" ));
const SearchCompanyCPersonView= React.lazy(() => import( "@/views/Window/Search/CompanyCPerson" ));
const AddWorkerView = React.lazy(() => import( "@/views/Window/CompanyPersonWorker/AddWorker" ));
const AddPersonView = React.lazy(() => import( "@/views/Window/CompanyPersonWorker/AddPerson" ));
const AddCompanyView = React.lazy(() => import( "@/views/Window/CompanyPersonWorker/AddCompany" ));
const CreateDossierView = React.lazy(() => import( "@/views/Window/Dossier/CreateDossierView" ));
const ChangeLanguageLabelsView = React.lazy(() => import( "@/views/Window/Settings/ChangeLanguageLabels" ));

const AddressController = React.lazy(() => import( "@/controllers/Base/Address" ));

import React, { useState, Suspense } from "react";
import BaseWindow from "@/views/Window/BaseWindow";
//import { TodoModel } from "@/models/CommunicicationCycle/Todo";
//import { ContactModel } from "@/models/CommunicicationCycle/Contact";
import PPCEvent from "@/Events/Event";
import { WorkerModel } from "@/models/PPC/Worker";
import { CompanyModel } from "@/models/PPC/Company";
import {TodoModel, ContactModel, AppointmentModel} from '@/models/CommunicicationCycle/CommunicationCycle';
import { AddressModel } from "@/models/PPC/Address";
import { PersonModel } from "@/Services/UserPersonCompanyService";

export const initialState = {
  windows: DB.newCollection(null, WindowModel),
  loadWindow: null,
  hasFocus: null,
  key: "",
};

const WindowReducer = createSlice({
  name: 'window',
  initialState,
  reducers: {
      setPos(state, action) {
            let selectedWindow = state.windows.findChildByKey(action.payload.uid, 'uid');
            if(selectedWindow) {
                selectedWindow.x= action.payload.x;
                selectedWindow.y= action.payload.y;
            }
            //state.windows.resetWhere().get();
            //state.key = uuid().slice(0, 8);
      },
      setFocus(state, action) {
          let selectedWindow = state.windows.findChildByKey(action.payload.uid, 'uid');
          if(selectedWindow) {
          if(state.hasFocus && state.hasFocus.uid !== action.payload.uid) {
              state.hasFocus.zindex = 800;
          }
          selectedWindow.zindex = 900;
          state.hasFocus = selectedWindow;
          } 
      },
      openChild(state, action) {
                let data = null;
                if(action.payload.data) {
                    data = action.payload.data;
                    action.payload.data = null;
                }
                
                
        //let customData = action.payload.data;
        //action.payload.data = null;

                    let newWindow = DB.newModel(action.payload, WindowModel);
                    newWindow.data = data;
                    newWindow.zindex = 900;
                    newWindow.x = 100;
                    newWindow.y = 100;
                    state.windows.add(newWindow);
                    
                      if(state.hasFocus && state.hasFocus.uid !== action.payload.uid) {
                          state.hasFocus.zindex = 800;
                      }
                  window.zindex = 900;
                  state.hasFocus = window; 
                    
                    
                    state.key = uuid().slice(0, 8);
        
        },
      open(state, action) {
        let data = null;
        if(action.payload.data) {
            data = {...action.payload.data};
            action.payload.data = null;
        }
//let customData = action.payload.data;
//action.payload.data = null;

            let newWindow = DB.newModel(action.payload, WindowModel);
            let lastItem = state.windows.last();
            let windowIndex = 1;
            if(lastItem) {
                windowIndex = lastItem.index + 1;
            }
            newWindow.index = windowIndex;
            newWindow.data = data;
            newWindow.zindex = 900;
            if(newWindow.top < 0) {
                newWindow.top = 0; 
            }
            //newWindow.x = 100;
            //newWindow.y = 100;
            let index = state.windows.length+1;
            let SelectedWindow;
            let addProps = {};
             
            switch(newWindow.childWindow) {
                
                case WINDOW.CHANGE_LANGUAGE_LABELS.childWindow:
                    newWindow.title = WINDOW.CHANGE_LANGUAGE_LABELS.title;
                    newWindow.style = WINDOW.CHANGE_LANGUAGE_LABELS.style;
                    newWindow.style.height = 200;
                    newWindow.style.width = 200;
                    SelectedWindow = ChangeLanguageLabelsView;
                    
                    break;
                case WINDOW.SETTINGS_COLOR.childWindow:
                    newWindow.title = WINDOW.SETTINGS_COLOR.title;
                    newWindow.style = WINDOW.SETTINGS_COLOR.style;
                    newWindow.style.height = 200;
                    newWindow.style.width = 200;
                    SelectedWindow = ColorSelectView;
                    break;
                    
                
                case WINDOW.CREATE_DOSSIER.childWindow:
                    newWindow.title = WINDOW.CREATE_DOSSIER.title;
                    newWindow.style = WINDOW.CREATE_DOSSIER.style;
                    SelectedWindow = CreateDossierView;
                    break;
                case WINDOW.ADD_COMPANY.childWindow:
                    newWindow.title = WINDOW.ADD_COMPANY.title;
                    newWindow.style = WINDOW.ADD_COMPANY.style;
                    newWindow.setData('data', DB.newModel(null, CompanyModel));
                    SelectedWindow = AddCompanyView;    
                    break;
                case WINDOW.DROPBOX_CONNECT.childWindow:
                    newWindow.title = WINDOW.DROPBOX_CONNECT.title;
                    newWindow.style = WINDOW.DROPBOX_CONNECT.style;
                    if(newWindow?.data?.type == "waiting") {
                        newWindow.style.height = 320;
                        newWindow.style.minHeight = null;
                    } else {
                        newWindow.style = WINDOW.DROPBOX_CONNECT.style;
                        newWindow.style.minHeight = "70%";
                        newWindow.style.height = "70%";
                    }
                    SelectedWindow = WindowDropbox;
                    
                    break;
                case WINDOW.ADD_PERSON.window:
                    newWindow.title = WINDOW.ADD_PERSON.title;
                        SelectedWindow = AddPersonView;
                    break;
                case WINDOW.ADD_WORKER.childWindow:
                    newWindow.title = WINDOW.ADD_WORKER.title;
                    newWindow.setData('data', DB.newModel(null, PersonModel));
                    SelectedWindow = AddWorkerView;
                    break;
                case WINDOW.SEARCH_CUSTOMER_CPERSON.childWindow:
                    newWindow.title = WINDOW.SEARCH_CUSTOMER_CPERSON.title;
                    SelectedWindow = SearchCompanyCPersonView;
                    break;
                case WINDOW.SEARCH_COMPANY_WORKERS_PERSONS.childWindow:
                    newWindow.title = WINDOW.SEARCH_COMPANY_WORKERS_PERSONS.title;
                    SelectedWindow = SearchCompanyWorkersPersonView;
                    
                    break;
                case WINDOW.WORKHOURS_ITEM_EDIT:
                    SelectedWindow = WorkhourView;
                    break;
                case WINDOW.ADDRES_WINDOW.childWindow:
                    newWindow.title = WINDOW.ADDRES_WINDOW.title;
//                    addProps.settings = action.state?.TenantReducer?.settings;
                    newWindow.setData('data', DB.newModel(data, AddressModel));
                    SelectedWindow = AddressController;
                    break;
                case WINDOW.TODO_WINDOW.childWindow:
                    newWindow.title = WINDOW.TODO_WINDOW.title;
                    addProps.settings = action.state?.TenantReducer?.settings;
                    newWindow.setData('data', DB.newModel(data, TodoModel));
                    SelectedWindow = WindowController;
                    break;
                case WINDOW.CONTACT_WINDOW.childWindow:
                    newWindow.title = WINDOW.CONTACT_WINDOW.title;
                    addProps.settings = action.state?.TenantReducer?.settings;
                    newWindow.data = DB.newModel(data, ContactModel);
                    //newWindow.setData('data', DB.newModel(data, ContactModel));
                    SelectedWindow = ContactController;
                    break;

                case WINDOW.APPOINTMENT_WINDOW.childWindow:
                    newWindow.title = WINDOW.APPOINTMENT_WINDOW.title;
                    addProps.settings = action.state?.TenantReducer?.settings;
                    newWindow.data = DB.newModel(data, AppointmentModel);
                    //newWindow.setData('data', DB.newModel(data, ContactModel));
                    SelectedWindow = AppointmentView;
                    break;
                                        
                case 'searchDossier':
                    SelectedWindow = SearchDossier;
                    break;
                    
                case 'setTimerData':
                    SelectedWindow = SetTimeRegistration;
                    break;
                
                
                case 'addWorker':
                    SelectedWindow = AddTask;
                    break;
                case 'search':
                    //TestMe = React.lazy(() => import( "@/controllers/Window/Search/WindowSearchController" ));
                    SelectedWindow = Search;
                    break;
                    
                    case 'timeRegistration':
                        SelectedWindow = TimeReg;                
            }
            let ppcEventClass = new PPCEvent();

                        

            
//                
                if(action?.payload?.childof) {
                    
                    let currentWindow = state.windows.findChildByKey(action?.payload?.childof, 'uid');
                    if(currentWindow) {
                        const newEl = (<SelectedWindow window={newWindow} id={newWindow.uid} {...addProps} ppcEventClass={ppcEventClass}/>);

                    currentWindow.childElements.push( newEl );
                    }
                    console.debug( state.windows.findChildByKey(action?.payload?.childof, 'uid') );
  //                  data?.childof["childElements"].push( newWindow );
                    //state.hasFocus = window;
                    state.key = uuid().slice(0, 8);
                } else {
                    newWindow.element = (
                        <BaseWindow key={newWindow.uid} id={"base_"+newWindow.uid} window={newWindow} index={index} ppcEventClass={ppcEventClass}>
                            <Suspense fallback={   (<div name="loadingPanel" className="loadingPanel"> Loading!!!!</div>) }>
                            <SelectedWindow window={newWindow} id={newWindow.uid} {...addProps} ppcEventClass={ppcEventClass}/>
                            </Suspense>   
                        </BaseWindow>)
            
                    state.windows.add(newWindow);
                        if(state.hasFocus && state.hasFocus.uid !== action.payload.uid) {
                            state.hasFocus.zindex = 800;
                        }
                    window.zindex = 900;
                    state.hasFocus = window; 
                    
                }
            
            
            
            //state.key = uuid().slice(0, 8);
      },
      close(state, action) {
//            let result = state.windows.findOne(action.payload.uuid);
//            
            state.windows = state.windows.delete(action.payload.uid);
            
//            state.key = uuid().slice(0, 8);
//            

      }      
    // omit existing reducers here
  }
  
});
export const { open, close, setPos,setFocus } = WindowReducer.actions;
export default WindowReducer.reducer